module.exports = __webpack_public_path__ + "afc3481bf31f3e55bdf132e9dcb4d824.svg";